import http from "infra/http";
import { useQuery } from "react-query";
import { ConfiguracaoWhiteLabelForm } from "../typings";

function useConfiguracaoWhiteLabel(tenantId: string) {
  return useQuery([`/v1/configuracao-whitelabel`], async () => {
    const { data } = await http.get<ConfiguracaoWhiteLabelForm>(
      `/v1/configuracao-whitelabel`,
      {
        headers: {
          tenant: tenantId,
        },
      }
    );

    return data;
  });
}

export default useConfiguracaoWhiteLabel;
